import {Component, ChangeDetectionStrategy} from "@angular/core";
import {PerformaInfoService} from "src/app/services/performa-info.service";

@Component({
    selector: "app-error-invalid",
    templateUrl: "./error-invalid.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorInvalidComponent {
    constructor(public readonly infoService: PerformaInfoService) {}
}
